const OrdersIcon = ({ active }) => {
  const color = active ? "#1E1E1E" : "#969696";
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.33333 1.16667H11.6667C12.3101 1.16667 12.8333 1.68992 12.8333 2.33333V11.6667C12.8333 12.3101 12.3101 12.8333 11.6667 12.8333H2.33333C1.68992 12.8333 1.16667 12.3101 1.16667 11.6667V2.33333C1.16667 1.68992 1.68992 1.16667 2.33333 1.16667Z"
        stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"
      />
      <path d="M4.08333 4.66667H9.91667" stroke={color} strokeWidth="1.16667" strokeLinecap="round" />
      <path d="M4.08333 7H9.91667" stroke={color} strokeWidth="1.16667" strokeLinecap="round" />
      <path d="M4.08333 9.33333H7" stroke={color} strokeWidth="1.16667" strokeLinecap="round" />
    </svg>
  );
};

export default OrdersIcon;
